var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBundleGcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Bundles/AWS@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 29,
    height: 29.1428571
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 10.9687347 0 10.9687347 10.6702065 0 10.6702065"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0.055161909 29 0.055161909 23.0670117 4.85714286 6.09289309 4.85714286"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Bundles/AWS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64",
    transform: "translate(0, 4.8571)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#34A853",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.625, 7.2857)",
    id: "Group-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4366103,2.07550997 C16.7604984,2.25003674 16.9772085,2.53660055 17.2155091,2.79589832 C17.8582051,3.49526657 18.367765,4.27955597 18.7119116,5.15621363 C18.8084647,5.40217865 18.890397,5.65496019 18.9829232,5.90347765 C19.0263519,6.02013912 19.0844325,6.1071923 19.1913626,6.18439607 C20.6781935,7.25774167 21.5169384,8.69620614 21.7166426,10.4782589 C21.8268562,11.4617587 21.6616287,12.4164008 21.2555295,13.3202945 C20.4772503,15.0524997 19.1461682,16.1921186 17.2786697,16.7460579 C16.8737167,16.8661726 16.448753,16.878034 16.0427468,16.9934943 C15.9595445,17.0171569 15.8254481,16.9686606 15.7134379,16.9686305 C14.1968698,16.9682101 12.6803326,16.9687507 11.1637955,16.9675495 C11.0509799,16.9674594 10.9381952,16.9557482 10.8254725,16.9494422 C10.8292826,16.8201687 10.8359425,16.6909252 10.8362832,16.5616517 C10.8390401,15.4764147 10.8406509,14.3912078 10.8426024,13.3060009 C10.904431,13.3042892 10.9662597,13.3011062 11.0280884,13.3010762 C12.5550645,13.3003555 14.0821336,13.3081629 15.6090168,13.2969022 C16.8062503,13.2881038 17.8186484,12.3461937 17.9011073,11.1909299 C17.9892658,9.95627015 17.0889709,8.89625729 15.8186333,8.73908711 C15.5487989,8.7056952 15.5483962,8.7056952 15.5466306,8.43459617 C15.5445242,8.11500079 15.5449578,7.79648644 15.4978739,7.47761175 C15.4782039,7.34446453 15.3933909,7.24440893 15.3742165,7.11558583 C15.2566925,6.32595133 14.8564479,5.68192595 14.2972329,5.1102397 C14.1437764,4.95333978 13.9381248,4.84733849 13.8263314,4.65203188 C14.0083481,4.40952015 14.2375107,4.20940894 14.4542827,3.99845738 C15.1139538,3.3564139 15.7757002,2.71635231 16.4366103,2.07550997",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0, 5.0601)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39310414,10.6702065 C1.29360078,9.85970206 0.581022242,8.79572542 0.188026071,7.51959606 C0.124679561,7.31386949 0.139331345,7.08838403 0.0168820772,6.89854264 C0.0201655638,6.22505911 -0.0530314058,5.55103507 0.0820561881,4.87926319 C0.206054271,4.26247384 0.444788526,3.69273945 0.710503128,3.12237446 C0.960760563,2.58519117 1.37249739,2.18121517 1.75043908,1.74712038 C2.01376851,1.44467139 2.37123488,1.24086665 2.68967113,0.996403063 C2.77813941,0.945774687 2.86651476,0.895356512 2.9547662,0.844698107 C3.88083332,0.313250302 4.87588464,0.0179481367 5.95745272,0.00092186783 C6.42061019,-0.00637510452 6.87850168,0.0301397859 7.33564975,0.0929598113 C7.93367797,0.249169071 8.52117426,0.430692519 9.06672865,0.723862647 C9.81604507,1.12651739 10.4554886,1.64940702 10.9687347,2.308717 C10.9516358,2.34036724 10.9456574,2.36111707 10.9321827,2.37502035 C10.1127979,3.21921699 9.21476434,3.98584952 8.37397494,4.8090561 C8.24858292,4.93184343 8.22256284,4.92397591 8.1194118,4.77076952 C8.03543508,4.64612042 7.95811827,4.51780781 7.85131202,4.40886371 C7.55734705,4.10899719 7.23163137,3.878557 6.79737478,3.7808136 C6.4599191,3.70487104 6.13612396,3.61823826 5.78333501,3.65787614 C5.53301562,3.68601302 5.31299104,3.79045281 5.07896518,3.85915846 C4.87703076,3.91846513 4.71555137,4.02921095 4.5607009,4.17355888 C4.29792905,4.41853295 4.10042423,4.6988508 3.92695702,5.00616444 C3.85719841,5.12967246 3.81274744,5.24203983 3.78663443,5.38194351 C3.71541994,5.76303765 3.75002046,6.13683481 3.78781153,6.51549663 C3.7972593,6.6101771 3.81850903,6.7014343 3.86878355,6.76332343 C3.97865644,6.89851261 4.03388716,7.06177861 4.13840116,7.19765844 C4.39999592,7.53776342 4.6575018,7.88177212 5.10662701,8.01209665 C5.06827836,8.0588213 5.03420445,8.10965987 4.99099252,8.15160996 C4.12566991,8.99175273 3.25926312,9.83087452 2.39310414,10.6702065",
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.3355785,5.15307863 C6.87849239,5.09019855 6.42063187,5.05368366 5.95744343,5.06098063 C4.87587534,5.0780069 3.88082403,5.37330907 2.95475691,5.90475687 C2.86650546,5.95541528 2.77813011,6.00586348 2.68969281,6.05646183 C2.60769857,5.97066985 2.67265585,5.8862592 2.69746786,5.80548201 C2.84776481,5.31580412 3.05911603,4.85056958 3.29218162,4.39275213 C3.55743158,3.87166422 3.92394302,3.41979245 4.28255551,2.95996308 C4.4678247,2.72237606 4.66675442,2.49800167 4.88563287,2.29287567 C5.23327976,1.96712441 5.62844427,1.6952146 6.02583908,1.43051167 C7.70837814,0.309900912 9.58154527,-0.134553771 11.6012922,0.0349281716 C13.3844732,0.184591177 14.9596175,0.851738645 16.3307519,1.96802527 C16.3697201,1.9997656 16.4015637,2.03967373 16.4366599,2.07564811 C15.7756878,2.7163403 15.1139723,3.35640188 14.4543013,3.99844536 C14.2375292,4.20942696 14.0083357,4.40953817 13.826319,4.65204989 C13.7576756,4.65144932 13.7157027,4.60244249 13.6678133,4.56685849 C13.1732149,4.19933732 12.6128849,3.96454297 12.0184189,3.79980556 C11.3362901,3.61074491 10.6454259,3.63750048 9.95471662,3.73800651 C9.56847328,3.79422022 9.20456384,3.9341239 8.84914191,4.08285602 C8.26381396,4.32777004 7.77293272,4.70697237 7.3355785,5.15307863",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39310414,15.7302683 C3.25926312,14.8909363 4.12566991,14.0518145 4.99099252,13.2116717 C5.03420445,13.1697216 5.06827836,13.1188831 5.10659603,13.0721884 C5.5025969,13.2288481 5.91362128,13.2864732 6.34171358,13.2840108 C7.71969377,13.2761433 9.09779787,13.2800471 10.47584,13.2814884 C10.5981034,13.2816086 10.7230308,13.2612191 10.8425993,13.3059918 C10.8406478,14.3911988 10.839037,15.4764057 10.8362801,16.5616427 C10.8359394,16.6909162 10.8292795,16.8201597 10.8254694,16.9494332 C9.22873464,16.9496734 7.63206185,16.9466405 6.03542004,16.9534363 C5.78119764,16.9545381 5.52812137,16.8553233 5.27355823,16.9451992 C4.93498739,16.7654474 4.52839263,16.8426512 4.1892952,16.690706 C3.56809671,16.41234 2.91195697,16.1901877 2.39310414,15.7302683",
    id: "Fill-23",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5",
    transform: "translate(14.5, 2.4562) scale(1, -1) translate(-14.5, -2.4562)"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#1F7837",
    transform: "translate(14.5, 2.4562) scale(1, -1) translate(-14.5, -2.4562)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#145927",
    x: 13.2916667,
    y: 0,
    width: 2.41666667,
    height: 4.85714286
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fillOpacity: 0.2,
    fill: "#000000",
    x: 13.2916667,
    y: 4.85714286,
    width: 2.41666667,
    height: 2.42857143
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundleGcp);
export default __webpack_public_path__ + "static/media/BUNDLE_GCP.e4d5a1c40f2c5da48f993aec32838fb8.svg";
export { ForwardRef as ReactComponent };